import object from 'helpers/object'


export const initialState = {
  params: {
    capacity: '21',
    closeTime: '20',
    editTime: '20',
    withNumbers: false,
  },
  labels: [],
  sessions: [],
  templates: {},
  isFetching: true,
}


export const setLabels = (state, payload) => (
  object.setIn(
    state,
    [ 'labels' ],
    payload
    // payload.sort((a, b) => (
    //   a.lbl > b.lbl
    //     ? 1
    //     : a.lbl < b.lbl
    //     ? -1
    //     : 0
    // ))
  )
)

export const setSessions = (state, payload) => (
  object.setIn(state, [ 'sessions' ], payload
    .sort((a, b) => {
      if (a.start === b.start) {
        return a.start < b.start ? -1 : a.start > b.start ? 1 : 0
      }

      return a.start < b.start ? -1 : a.start > b.start ? 1 : 0
    })
  )
)

export const setLabelSessions = (state, payload) => (
  object.setIn(state, [ 'templates', payload.id ], payload.sessions)
)

export const setFetching = (state, payload) => (
  object.setIn(state, [ 'isFetching' ], payload)
)

export const setParams = (state, payload) => (
  object.setIn(state, [ 'params' ], payload)
)
